import React from 'react';
import { Shield, Zap, Users, Award } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  Shield: Shield,
  Zap: Zap,
  Users: Users,
  Award: Award
};

const WhyChooseSection = () => {
  return (
    <section id="why-choose" className="relative bg-gray-50 py-32">
      {/* Background Accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#0099FF]/5 rounded-full blur-[200px]"></div>

      <div className="relative max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-6 tracking-tight">
            Why Leading Businesses Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Combining traditional accounting excellence with modern technology and personalized service.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div 
                key={item.id}
                className="group bg-white border border-gray-200 p-8 hover:bg-white hover:border-[#0099FF]/50 hover:shadow-lg transition-all duration-400"
              >
                {/* Icon */}
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center mb-6 group-hover:bg-[#0099FF]/20 transition-all duration-400">
                  <IconComponent className="text-[#0099FF]" size={24} />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
